import React, { useState, useEffect } from "react";
import "./Nav.css";

const Nav = () => {
  const [handleShow, setHandleShow] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setHandleShow(true);
      } else setHandleShow(false);
    });

    return () => {
      window.removeEventListener("scroll");
    };
  }, []);

  return (
    <div className={`nav  ${handleShow && "shownav"}`}>
      <img
        className="logo logo1"
        src="https://upload.wikimedia.org/wikipedia/commons/0/0f/Logo_Netflix.png"
        alt="Netfilx logo"
      />

      <img
        className="logo logo2"
        src="https://pbs.twimg.com/profile_images/1240119990411550720/hBEe3tdn_400x400.png"
        alt="Netflix logo"
      />
    </div>
  );
};

export default Nav;
